// extracted by mini-css-extract-plugin
module.exports = {"accountName":"wallet-cover_accountName__70F-v"};